import React from "react";
import { Link } from "react-router-dom";
import * as styles from "@styles/NotFound.css";
import type { NotFoundViewProps } from "@ps-bridge/contracts/notFound";
import { renderRoute } from "@navigation/typedRoutes";

const NotFoundView: React.FC<NotFoundViewProps> = ({
  path,
  homeRoute,
  loginRoute,
}) => (
  <div className={styles.page}>
    <div className={styles.backdrop} aria-hidden="true" />
    <div className={styles.grid} aria-hidden="true" />
    <div className={styles.orbit} aria-hidden="true">
      <span className={styles.orbitRing} />
      <span className={styles.orbitDot} />
    </div>
    <section className={styles.card}>
      <span className={styles.brand}>Ouroboros AI</span>
      <div className={styles.badge}>404</div>
      <h1 className={styles.title}>This loop has no exit.</h1>
      <p className={styles.copy}>
        We could not find <span className={styles.path}>{path}</span>. Check the
        address or return to safety.
      </p>
      <div className={styles.actions}>
        <Link to={renderRoute(homeRoute)} className={styles.primary}>
          Go to workspace
        </Link>
        <Link to={renderRoute(loginRoute)} className={styles.ghost}>
          Back to login
        </Link>
      </div>
    </section>
  </div>
);

export default NotFoundView;
